import { useStore } from "#src/stores/Store.tsx";
import { useUI } from "#src/stores/UI.tsx";
import tw from "#src/utils/tw.ts";
import { ReactNode } from "react";

interface Props {
  className?: string;
  children?: ReactNode;
}

export const MenuContainer = (props: Props) => {
  const store = useStore();
  const ui = useUI();

  let top = 50;

  if (store.user?.isSalesOrAbove || store.isSuperAdminArea) {
    top += 30;
  }

  if (store.superAdmin) {
    top += 30;
  }

  return (
    <nav
      className={tw(
        "fixed bottom-0 left-0 w-[300px] z-30 transform overflow-y-auto bg-bgGray transition",
        ui.menuOpen && "shadow",
        props.className
      )}
      style={{
        top,
        transform: ui.menuOpen ? "translateX(0)" : "translateX(-100%)",
      }}
    >
      {props.children}
    </nav>
  );
};
